export default __webpack_public_path__ + "static/joko-app-screenshot-home-fr@2x-a23b9c2f64e8c0faed5e5b7a3880d9a9.webp";